
import React from 'react'
import { object } from 'prop-types'
import Image from './Image'
import ResponsiveLayout from '../responsive-layout/ResponsiveLayout'

const ResponsiveImage = ({ imageProps }) => {
  const { commonProps, large, small } = imageProps
  return <ResponsiveLayout
    renderLarge={() => <Image {...large} {...commonProps} />}
    renderSmall={() => <Image {...small} {...commonProps} />}
  />
}

ResponsiveImage.propTypes = {
  imageProps: object
}

export default ResponsiveImage